import React from "react";
import styles from "./style.module.css";

// Slider Images
import ESBN from "../../assets/Home/ESBN.png";
import Payment from "../../assets/Home/payment.png";
import ServiceProcess from "../../assets/Home/serviceProcess.png";
// import Comingsoon from "../../assets/Home/comingsoon.png";
// import Traffic from "../../assets/Home/traffic.png";
// import eTransact from "../../assets/Home/E-transact.png";
import StepstoPay from "../../assets/Home/StepstoPay.png";
import LandUseCharge from "../../assets/Home/LandUseCharge.png";
import myPaye from "../../assets/Home/Paye.png";
import PurchaseTax from "../../assets/Home/PurchaseTax.png";
import Withholdingtax from "../../assets/Home/Withholdingtax.png";

const HomeSlider = () => {
	return (
		<>
			<div
				id="home-slider"
				className="carousel slide"
				data-ride="carousel"
			>
				<ol
					className={`${styles.slider___indicators} carousel-indicators`}
				>
					<li
						data-target="#home-slider"
						data-slide-to="0"
						className={`active ${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="1"
						className={`${styles.slider__icons}`}
					></li>
					{/* <li
						data-target="#home-slider"
						data-slide-to="2"
						className={`${styles.slider__icons}`}
					></li> */}
					<li
						data-target="#home-slider"
						data-slide-to="3"
						className={`${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="4"
						className={`${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="5"
						className={`${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="6"
						className={`${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="7"
						className={`${styles.slider__icons}`}
					></li>
					<li
						data-target="#home-slider"
						data-slide-to="8"
						className={`${styles.slider__icons}`}
					></li>
					{/* <li
						data-target="#home-slider"
						data-slide-to="9"
						className={`${styles.slider__icons}`}
					></li> */}
				</ol>

				<div className="carousel-inner" role="listbox">
					<div className="item">
						<img
							src={StepstoPay}
							alt="StepstoPay"
							className={styles.slider__image}
						/>
					</div>
					{/* <div className="item">
						<img
							src={Traffic}
							alt="Traffic"
							className={styles.slider__image}
						/>
					</div> */}
					<div className="item">
						<img
							src={myPaye}
							alt="PAYE"
							className={styles.slider__image}
						/>
					</div>
					<div className="item">
						<img
							src={LandUseCharge}
							alt="LandUseCharge"
							className={styles.slider__image}
						/>
					</div>
					<div className="item">
						<img
							src={Withholdingtax}
							alt="Withholdingtax"
							className={styles.slider__image}
						/>
					</div>
					<div className="item">
						<img
							src={PurchaseTax}
							alt="PurchaseTax"
							className={styles.slider__image}
						/>
					</div>
					<div className="item active">
						<img
							src={ESBN}
							alt="ESBN"
							className={styles.slider__image}
						/>
					</div>
					<div className="item">
						<img
							src={Payment}
							alt="Payment"
							className={styles.slider__image}
						/>
					</div>
					<div className="item">
						<img
							src={ServiceProcess}
							alt="Service Process"
							className={styles.slider__image}
						/>
					</div>
					{/* <div className="item">
						<img
							src={Comingsoon}
							alt="Coming soon"
							className={styles.slider__image}
						/>
					</div> */}
				</div>
			</div>
		</>
	);
};

export default HomeSlider;
